import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Yup from '../../../utils/yupExtensions';
import toast from 'react-hot-toast';
import i18next from 'i18next';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';

import styles from './VerifyOTPForm.module.css';
import Button from '../../UI/Buttons/Button/Button';
import { fetchUserByToken } from '../../../app/features/userSlice';
import {
    resendOTPCode,
    verifyOTPCode
} from '../../../services/authService';
import OTPInput from 'otp-input-react';
import { Margin } from '@mui/icons-material';

function VerifyOTPForm(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [formLoading, setFormLoading] = useState(false);
    const [OTP, setOTP] = useState("");

    const currentLanguage = i18next.language;

    const formik = useFormik({
        initialValues: {
            otp_code: OTP,
        },
        validationSchema: Yup.object({
        }),
        onSubmit: values => {
            if (formLoading) {
                return;
            }

            setFormLoading(true);
            const formData = new FormData();
            formData.append('otp_code', OTP);
            formData.append('email', props.email);

            toast.promise(verifyOTPCode(props.email, OTP), {
                loading: t('general.UI.loading'),
                success: t('general.UI.success'),
                error: (err) => {
                    let error_msg = err.error;
                    return <b>{error_msg}</b>;
                },
            })
                .then((response) => {
                    if (response.success) {
                        dispatch(fetchUserByToken(props.token));
                    }
                })
                .catch((error) => {
                    if (error?.error) {
                        formik.setErrors({
                            // otp_code: error?.error
                        });
                    }
                    setFormLoading(false);
                });
        },
    });

    // Function to handle the resend OTP code action
    const handleResendCode = () => {
        toast.promise(resendOTPCode(props.email, props.accountType), {
            loading: t('general.UI.loading'),
            success: (props) => {
                let error_msg = props.message;
                if (error_msg === "OTP resend limit reached. Try again after 24 hours.") {
                    return <b>{error_msg}</b>
                } else {
                    error_msg = t('general.UI.success')
                    return <b>{error_msg}</b>
                }
            }
            ,
            error: (err) => {
                let error_msg = err.error;
                if (error_msg === "Invalid OTP") {
                    error_msg = t('general.UI.something_went_wrong')
                }
                return <b>{error_msg}</b>;
            },
        })
            .then((response) => {
            })
            .catch((error) => {
                if (error?.error) {
                    formik.setErrors({
                        otp_code: error?.error
                    });
                }

                setFormLoading(false);
            });
    };

    return (
        <form onSubmit={formik.handleSubmit} {...props} >
            <div className={styles.otpInputContainer}>
                <OTPInput
                    value={OTP}
                    onChange={setOTP}
                    autoFocus
                    OTPLength={6}
                    className={styles.otpInputContainer}
                    inputStyles={{
                        backgroundColor: '#ECF3F5',
                        width: '50px',
                        height: '40px',
                        margin: "5px",
                        backgroundColor: '#ECF3F5',
                        border: '0px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        fontSize: '18px',
                    }}
                    otpType="number"
                    disabled={false}
                />
            </div>
            <div className={styles.buttonContainer}>
                <Button type="submit" className={styles.verifyButton}>
                    {t('forms.verifyOTP.Verify')}
                </Button>
            </div>
            <p className={styles.signupText}>
                {t('forms.verifyOTP.did_receive_the_OTP_Click')}
                <span
                    onClick={handleResendCode}
                    className={styles.loginLink}>
                    {t('forms.verifyOTP.resendButton')}
                </span>
                {t('forms.verifyOTP.or_check_your_spam_folder')}
            </p>
        </form >
    );
}

export default VerifyOTPForm;
